import { on_ready } from 'src/js/utils';
import { ajax } from 'src/api/ajax';
import { create_element } from 'src/js/utils';
import { add_to_cart_ajax_init } from 'src/woocommerce/js/add_to_cart';

import './wishlist.scss';

const no_items_message = 'Your wishlist is currently empty';
const container = document.getElementById('wishlist_render');

let wishlist;

on_ready(()=>{
    if( !container ) return;
    if( typeof document.body.save_items_wishlist === 'undefined' ) return;

    wishlist = document.body.save_items_wishlist;

    if( !wishlist.items.length ) {
        container.innerHTML = `<div class="no_items">${no_items_message}</div>`;
        return;
    }

    ajax( 'wishlist', { items: wishlist.items }, { done: (res)=>render(res) } );
});

function render(res){

    if( !res.html ) {
        container.innerHTML = `<div class="no_items">${no_items_message}</div>`;
        return;
    }
    
    let items_container = create_element({ class_name: 'loop', render: container });
    items_container.style.opacity = 0;
    items_container.innerHTML = res.html;

    // initialize items - add remove button
    items_init(items_container);

    // show items
    setTimeout(()=>{
        items_container.style.opacity = 1;
        loading_complete();
    }, 50);
}

function loading_complete(){
    const spinner = container.querySelector('.spinner');
    const animation_duration = 300;
    spinner.style.transition = `all ${animation_duration}ms ease`;
    spinner.style.opacity = 0;
    spinner.style.transform = 'translateY(10px)';
    setTimeout(()=>spinner.remove(), animation_duration);
}

function items_init(items_container){
    
    let valid_item_ids = [];

    items_container.querySelectorAll('.item').forEach(item=>{
        let id = parseInt(item.dataset.id);
        valid_item_ids.push(id);
        let remove_button = create_element({class_name: 'remove_btn', render: item, render_method: 'prepend'});
        remove_button.addEventListener('click', ()=>{
            remove_item(id, item);
        })
    })

    if( wishlist.items.length != valid_item_ids.length ) {
        // have invalid ids, update items
        wishlist.set_items(valid_item_ids);
    }

    add_to_cart_ajax_init(items_container);
}

function remove_item(id, item){
    item.style.pointerEvents = 'none';
    item.style.opacity = 0;
    item.style.transform = 'scale(.9)';
    setTimeout(() => item.remove(), 300);

    wishlist.remove_item(id);
}